module.exports = __webpack_public_path__ + "img/image138.d0418c4.jpg";